import React from 'react';
import { useDispatch } from 'react-redux';
import * as actionTypes from '@redux/actionTypes';
import { paymentIntent } from '@services/api';
import { useSelector } from 'react-redux';
import BuyNft from '../FrodobotGamma/BuyNft';
import { safeLocalStorage } from "@utils/localstorage";
const NftMinting = () => {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.setUserDetails.user);

	const buyNft = async (amount) => {
		try {
			const resp = await paymentIntent({
				amount: amount,
				currency: 'USD',
				wallet_address: user.wallet_address,
				type: 'NFT',
				nft_tc: true
			});
			const clientSecretkey = resp?.data?.payment_intent?.client_secret;
			if (clientSecretkey) {
				dispatch({
					type: actionTypes.CLIENT_SECRET,
					payload: clientSecretkey
				});
				safeLocalStorage.setItem('nftMinting', false);
				dispatch({
					type: actionTypes.STRPIE_PAYMNET,
					payload: true
				});
				dispatch({
					type: actionTypes.PAYMENT_AMOUNT,
					payload: resp?.data?.payment.amount
				});
			}
		} catch (error) {
			console.log('error: ', error);
		}
	};

	return <BuyNft buyNft={buyNft} />;
};

export default NftMinting;
